export default "__VITE_ASSET__yAc$bvWJ__"